import React from 'react';

const PaginationControls = ({ 
    currentCount, 
    totalCount, 
    hasMore, 
    onLoadMore, 
    loading = false,
    itemType = 'items'
}) => {
    if (totalCount === 0) return null;

    return (
        <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="text-muted">
                Showing {Math.min(currentCount, totalCount)} of {totalCount} {itemType}
            </div>
            {hasMore && (
                <button 
                    className="btn btn-outline-primary btn-sm" 
                    onClick={onLoadMore}
                    disabled={loading}
                >
                    {loading ? (
                        <span>
                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                            Loading...
                        </span>
                    ) : (
                        `Load More (${totalCount - currentCount} remaining)`
                    )}
                </button>
            )}
        </div>
    );
};

export default PaginationControls;